export {
  ConditionalRuleMode,
  ConditionRuleOperator,
  defaultConditionalNode,
  defaultConditionalRuleNode,
  defaultRule,
  TConditionalNode,
  TConditionalRuleNode,
  TConditionRule,
};

const ConditionalRuleMode = {
  RULES: "rules",
  AI: "ai",
} as const;

const defaultConditionalRuleNode = {
  name: "Branch Condition",
  description: "",
  mode: ConditionalRuleMode.RULES,
  rules: [],
  defaultPort: "default",
} as const;

const defaultRule = {
  field: "",
  operator: "",
  value: "",
  outputPort: "",
};

const defaultConditionalNode = {
  [ConditionalRuleMode.RULES]: defaultConditionalRuleNode,
};

const ConditionRuleOperator = {
  EQUALS: "equals",
  NOT_EQUALS: "not_equals",
  CONTAINS: "contains",
  NOT_CONTAINS: "not_contains",
  GREATER_THAN: "greater_than",
  LESS_THAN: "less_than",
  EXISTS: "exists",
  NOT_EXISTS: "not_exists",
  REGEX_MATCH: "regex_match",
  IN: "in",
  NOT_IN: "not_in",
} as const;

type TConditionalNode = TConditionalRuleNode;

type TConditionalRuleNode = {
  nodeId: string;
  name: string;
  description?: string;
  mode: typeof ConditionalRuleMode.RULES;
  rules: Array<TConditionRule>;
  defaultPort: string;
};

type TConditionRule = {
  field: string;
  operator: typeof ConditionRuleOperator;
  value?: any;
  outputPort: string;
};
